jQuery(document).ready(function ($) {

    $('.js-search-terms li').on('click', function () {
        const $this = $(this);
        populate_search_field($this, $this.text());
    });

    $('.js-search-terms-select').on('change', function () {
        const $this = $(this);
        populate_search_field($this, $this.val());
    });

    $('.js-search').on('click', search_questions);

    function search_questions() {
        const $this = $(this),
            parent = $this.closest('.hero__faq__details'),
            searchField = parent.find('input[type="search"]'),
            query = searchField.val(),
            block = $this.closest('.hero__faq'),
            questions = block.find('.hero__faq__content');

        $.ajax({
            url: "/wp-json/faq/search",
            method: 'POST',
            data: {
                query: query
            },
            beforeSend: function () {
                $this.attr('disabled', true);
                questions.empty().addClass('processing');
            },
            success: function (response) {
                $this.removeAttr('disabled');
                questions.html(response.html).removeClass('processing');
            }
        });

        return false;
    }

    function populate_search_field($this, string) {
        const parent = $this.closest('.hero__faq__details'),
            searchField = parent.find('input[type="search"]');

        searchField.val(string);

        $('.js-search').trigger('click');

    }

});